
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hazirlik/[pathDetailSlug]",
      function () {
        return require("private-next-pages/hazirlik/[pathDetailSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hazirlik/[pathDetailSlug]"])
      });
    }
  